import { pathOr } from 'ramda';

import { IState } from 'shared/store';

export const selectTourV2BannerImageUrlV2 = (state: IState): string | null =>
  pathOr(null, ['offerData', 'tourV2', 'tourBannerImageUrl'], state);
